<template>
   <div>
          <div class="text-center Bullmeter-value" v-if="slider == 0">{{slider}}</div> 
            <div class="Bullmeter-img-container">
              <img src="@/assets/Images/Bear.png" class="img-fluid" alt="Responsive image" />
            <b-progress
                height="2em"
                :value="negativeSlider"
                :show-value="true"
                class="mb-0 negative-progressbar"
                style="width: 100%"
              ></b-progress> 
              <div class="center-value"></div>
             
         <b-progress
                height="2em"
                :value="positiveSlider"
                :show-value="true"
                class="mb-0 positive-progressbar"
                style="width: 100%"
              ></b-progress>
              <img src="@/assets/Images/Bull.png" class="img-fluid" alt="Responsive image" />
            </div>
            </div>
</template>
<script>
export default {   
    props:{
        slider: Number
    },
     computed: {
    positiveSlider() {
      return this.slider> 0 ? this.slider : 0;
    },
    negativeSlider() {
      return this.slider < 0 ? Math.abs(Number(this.slider)) : 0;
    }
  },
}
</script>